import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';

const CustomDialog = React.forwardRef((props, ref) => {
    return <Dialog ref={ref} {...props} />;
});

export { CustomDialog as Dialog };
